import resources from './resources';

export default {
    performOauth2Authorize(provider) {
        const query = '?client_id=' + provider.clientId + '&redirect_uri=' + provider.redirect + '&scope=' + provider.scope + '&response_type=' + provider.responseType + '&state=' + encodeURIComponent(JSON.stringify(provider.state));

        window.location = provider.url + query;

        this.authenticated = true;
    },

    authUser(context, token, callback) {
        const url = config.AUTH_USER_URL;

        resources.setToken(token);

        resources.fetchUser(context, url, callback);
    },

    logout() {
        resources.clearUserResource();
    },

    checkAuth() {
        const jwt = resources.getToken();

        if (! jwt) {
            this.logout();
            return false;
        }

        return true;
    },

    getUser() {
        return resources.getOauthUser();
    },

    isSuperMan() {
        return this.getUser().is_super_man;
    }
}



// WEBPACK FOOTER //
// ./src/libs/authService.js